// UserPasswordForm Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Input from '../../form/input/input.jsx'
import Button from '../../common/button/button.jsx'
import Typo from '../../typography/typo/typo.jsx'
import Util from '../../../lib/util.jsx'

import IntlMessage from '../../common/intl/intl_message.jsx'

class UserPasswordForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    }

    this.data = {
      user: _.cloneDeep(this.props.user)
    }

    this._references = {
      inputOldPassword: React.createRef(),
      inputNewPassword: React.createRef(),
      inputConfirmPassword: React.createRef()
    }
  }

  static get propTypes () {
    return {
      user: PropTypes.object,
      onSubmit: PropTypes.func,
      onError: PropTypes.func,
      onClickProfile: PropTypes.func,
      onShowPassWordError: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      user: null,
      onSubmit: null,
      onError: null,
      onClickProfile: null,
      onShowPassWordError: null
    }
  }

  render () {
    const user = this.data.user

    return (
      <form
        className='form'
        method='post'
        noValidate
        action='#'
        onSubmit={this._onFormSubmit.bind(this)}
      >
        <div className='userprofile-form userpassword-form'>
          <div className='col colleft'>
            <div className='introblock'>
              <Typo className='profile'>
                <h2>
                  <IntlMessage ident='user.profile.changeContentTitle' />
                </h2>
                <p>
                  <IntlMessage ident='user.profile.changeContentInfo' />
                  <b>{user.email}</b>
                </p>
                <div className='hintblock'>
                  <p>
                    <b>
                      <IntlMessage ident='user.profile.passwordHint' />
                    </b>
                    <IntlMessage ident='user.profile.passwordHintCharater' />
                  </p>
                  <p>
                    <IntlMessage ident='user.profile.passwordHintAlphanumeric' />
                  </p>
                  <p>
                    <IntlMessage ident='user.profile.passwordHintDigit' />
                  </p>
                  <p>
                    <IntlMessage ident='user.profile.passwordHintSpace' />
                  </p>
                </div>
              </Typo>
            </div>
          </div>
          <div className='col colright'>
            <div className='detailblock'>
              <div className='formrow'>
                <div className='formcol'>
                  <Input
                    type='password'
                    name='oldPassword'
                    className='showpassword'
                    allowShowPassword
                    label='user.profile.oldPassword'
                    value={this.state.oldPassword}
                    size={30}
                    maxLength={100}
                    onChange={this._onChangeInput.bind(this, 'oldPassword')}
                    ref={this._references.inputOldPassword}
                    validations={['required', 'password']}
                  />
                </div>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <Input
                    type='password'
                    name='newPassword'
                    className='showpassword'
                    allowShowPassword
                    label='user.profile.newPassword'
                    value={this.state.newPassword}
                    size={30}
                    maxLength={100}
                    onChange={this._onChangeInput.bind(this, 'newPassword')}
                    ref={this._references.inputNewPassword}
                    validations={['required', 'password']}
                  />
                </div>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <Input
                    type='password'
                    name='confirmPassword'
                    className='showpassword'
                    allowShowPassword
                    label='user.profile.repeatNewPassword'
                    value={this.state.confirmPassword}
                    size={30}
                    maxLength={100}
                    onChange={this._onChangeInput.bind(this, 'confirmPassword')}
                    ref={this._references.inputConfirmPassword}
                    validations={['required', 'password']}
                  />
                </div>
              </div>
              <button type='submit' style={{ display: 'none' }}>
                <IntlMessage ident='user.profile.tipSave' />
              </button>
              <Button
                className='button_user button_password'
                type='button'
                icon='profile-password-previous'
                onClick={this.props.onClickProfile}
              />
              <Button
                className='button_save'
                title='user.profile.tipSave'
                type='button'
                icon='common-success-tick'
                canHover={false}
                onClick={this._onFormSubmit.bind(this)}
              />
            </div>
          </div>
        </div>
      </form>
    )
  }

  /* Event handlers */
  _onChangeInput (name, value) {
    this.setState({ [name]: value })
  }

  /* Private Function */
  _onFormSubmit (ev) {
    ev.preventDefault()
    const user = this.data.user

    let noErrors = 0
    if (
      this._references.inputOldPassword.current &&
      !this._references.inputOldPassword.current.validate()
    ) {
      noErrors++
    }

    if (
      this._references.inputNewPassword.current &&
      !this._references.inputNewPassword.current.validate()
    ) {
      noErrors++
    }

    if (
      this._references.inputConfirmPassword.current &&
      !this._references.inputConfirmPassword.current.validate()
    ) {
      noErrors++
    }

    if (this.state.newPassword !== this.state.confirmPassword) {
      noErrors++
    }

    if (
      !this.state.newPassword ||
      !Util.isValidPassword(this.state.newPassword)
    ) {
      noErrors++
    }

    if (noErrors === 0) {
      if (this.props.onSubmit) {
        this.props.onSubmit(
          user.email,
          this.state.oldPassword,
          this.state.newPassword
        )
        this._clearForm()
      }
    } else if (this.state.newPassword !== this.state.confirmPassword) {
      if (this.props.onShowPassWordError) {
        this.props.onShowPassWordError()
      }
    } else if (this.props.onError) {
      this.props.onError()
    }
  }

  _clearForm () {
    this.setState({
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    })
  }
}

export default UserPasswordForm
